// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getTopShortenedActivities(projectId: string, startDate: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/top_shortened_activities${startDate ? `?start_date=${startDate}` : ''}`);
}
